const { initPerfume } = require('perfume.js');
const { trackMetric, sendMetrics, getMetricsCollected } = require('../collector');
const {
  LCP, CLS, FID, INP, WORKER_TIME, TOTAL_TIME, TTFB,
  HEADER_SIZE, FETCH_TIME, DOWNLOAD_TIME, DNS_LOOKUP_TIME,
  DEBUG_TARGET_LCP, DEBUG_TARGET_CLS, DEBUG_TARGET_FID, DEBUG_TARGET_INP,
  NAVIGATION_TIMING,
} = require('../../constants/metrics');
const { onBFCacheRestore } = require('../utils/bfcache');

module.exports = (settings, initiative) => {
  let perfumeSent = false;
  onBFCacheRestore(() => {
    perfumeSent = false;
  });

  // eslint-disable-next-line no-new
  return initPerfume({
    analyticsTracker: (options) => {
      if (perfumeSent) {
        return;
      }

      /* istanbul ignore next */
      const { attribution, metricName: originalMetricName, data } = options;
      /* istanbul ignore next */
      const metricName = typeof originalMetricName === 'string' ? originalMetricName.toLowerCase() : originalMetricName;

      /* istanbul ignore next */
      if (metricName === LCP && attribution) trackMetric(DEBUG_TARGET_LCP, attribution.element);
      /* istanbul ignore next */
      if (metricName === CLS && attribution) trackMetric(DEBUG_TARGET_CLS, attribution.largestShiftTarget);
      /* istanbul ignore next */
      if (metricName === FID && attribution) trackMetric(DEBUG_TARGET_FID, attribution.eventTarget);
      /* istanbul ignore next */
      if (metricName === INP && attribution) trackMetric(DEBUG_TARGET_INP, attribution.eventTarget);
      /* istanbul ignore next */
      if (metricName === NAVIGATION_TIMING && data && typeof data === 'object') {
        trackMetric(DNS_LOOKUP_TIME, data.dnsLookupTime);
        trackMetric(DOWNLOAD_TIME, data.downloadTime);
        trackMetric(FETCH_TIME, data.fetchTime);
        trackMetric(HEADER_SIZE, data.headerSize);
        trackMetric(TTFB, data.timeToFirstByte);
        trackMetric(TOTAL_TIME, data.totalTime);
        trackMetric(WORKER_TIME, data.workerTime);
      }

      trackMetric(metricName, data);

      perfumeSent = sendMetrics(initiative, settings, getMetricsCollected());
    },
  });
};
